import React, { HTMLAttributes } from 'react';

const RuggedTrashCan = ({
  className,
}: HTMLAttributes<HTMLElement>): JSX.Element => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="3 0 18.22 24"
  >
    <path
      d="M12.11 7.948a.639.639 0 1 0 0-1.278.639.639 0 0 0 0 1.278Z"
      fill="#000"
    />
    <path
      d="M18.775 3.058H15.11l.001-.059c0-1.653-1.345-2.999-3-2.999-1.653 0-2.999 1.346-2.999 3l.002.058H5.446A2.45 2.45 0 0 0 3 5.504c0 .965.562 1.801 1.376 2.2v13.373A2.927 2.927 0 0 0 7.3 24h9.623a2.927 2.927 0 0 0 2.924-2.923V7.703a2.449 2.449 0 0 0 1.376-2.2 2.45 2.45 0 0 0-2.447-2.445Zm-8.383-.059c0-.948.77-1.719 1.719-1.719.948 0 1.719.771 1.719 1.72l-.002.058h-3.434l-.002-.059Zm8.383 3.671H14.98a.64.64 0 0 0 0 1.28h3.585v13.127c0 .906-.737 1.643-1.643 1.643H7.3a1.645 1.645 0 0 1-1.643-1.643V7.95h3.585a.64.64 0 1 0 0-1.28H5.446A1.167 1.167 0 0 1 4.28 5.504c0-.643.523-1.166 1.166-1.166H18.775a1.167 1.167 0 0 1 0 2.332Z"
      fill="#000"
    />
    <path
      d="M8.432 10.695a.64.64 0 0 0-.64.64v8.752a.64.64 0 0 0 1.28 0v-8.752a.64.64 0 0 0-.64-.64ZM12.11 10.695a.64.64 0 0 0-.64.64v8.752a.64.64 0 0 0 1.281 0v-8.752a.64.64 0 0 0-.64-.64ZM15.79 20.727a.64.64 0 0 0 .64-.64v-8.752a.64.64 0 0 0-1.28 0v8.752c0 .353.286.64.64.64Z"
      fill="#000"
    />
  </svg>
);
export default RuggedTrashCan;
